import React, { createContext, useContext, useEffect, useState } from "react";

interface CurrencyContextProps {
  exchangeRate: number;
  currencySymbol: string;
  language: string;
  setLanguage: (language: string) => void;
  currency: string;
}

const CurrencyContext = createContext<CurrencyContextProps | undefined>(
  undefined
);

export const CurrencyProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [exchangeRate] = useState<number>(1);
  const [currencySymbol, setCurrencySymbol] = useState<string>("₺");
  const [currency, setCurrency] = useState<string>("");
  const [language, setLanguage] = useState<string>("pl");

  const fetchExchangeRate = async () => {
    try {
      if (language === "de") {
        setCurrencySymbol("€");
        setCurrency("EUR");
      } else if (language === "tr") {
        setCurrencySymbol("₺");
        setCurrency("");
      } else if (language === "en") {
        setCurrencySymbol("$");
        setCurrency("USD");
      } else if (language === "nl") {
        setCurrencySymbol("€");
        setCurrency("EUR");
      } else if (language === "fr") {
        setCurrencySymbol("€");
        setCurrency("EUR");
      } else if (language === "be") {
        setCurrencySymbol("€");
        setCurrency("EUR");
      } else if (language === "pl") {
        setCurrencySymbol("zł");
        setCurrency("PLN");
      } else if (language === "uk") {
        setCurrencySymbol("£");
        setCurrency("GBP");
      } else if (language === "cz") {
        setCurrencySymbol("Kč");
        setCurrency("CZK");
      } else if (language === "at") {
        setCurrencySymbol("€");
        setCurrency("EUR");
      } else if (language === "ch") {
        setCurrencySymbol("CHF");
        setCurrency("CHF");
      } else if (language === "it") {
        setCurrencySymbol("€");
        setCurrency("EUR");
      } else if (language === "dk") {
        setCurrencySymbol("DKK");
        setCurrency("DKK");
      } else if (language === "se") {
        setCurrencySymbol("kr");
        setCurrency("SEK");
      } else if (language === "es") {
        setCurrencySymbol("€");
        setCurrency("EUR");
      } else if (language === "eu") {
        setCurrencySymbol("€");
        setCurrency("EUR");
      }
    } catch (error) {
      console.error("Error fetching exchange rate:", error);
    }
  };

  useEffect(() => {
    fetchExchangeRate();
  }, [language]);

  return (
    <CurrencyContext.Provider
      value={{ exchangeRate, currencySymbol, language, setLanguage, currency }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error("useCurrency must be used within a CurrencyProvider");
  }
  return context;
};
